import { render, staticRenderFns } from "./PageNumber.vue?vue&type=template&id=7fdd0880&"
import script from "./PageNumber.vue?vue&type=script&lang=js&"
export * from "./PageNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7fdd0880', component.options)
    } else {
      api.reload('7fdd0880', component.options)
    }
    module.hot.accept("./PageNumber.vue?vue&type=template&id=7fdd0880&", function () {
      api.rerender('7fdd0880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/bookmark/PageNumber.vue"
export default component.exports